import _ from '@lodash';
import TablePagination from '@fuse/components/general/TablePagination';
import Typography from '@material-ui/core/Typography';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';
import { makeStyles } from '@material-ui/core/styles';
import ListView from './listView';
import GridView from './gridView';
import useRouter from '@fuse/hooks/useRouter';


function EndUsersAccountsTable(props) {
	const [page, setPage] = useState(0);
	const router = useRouter();
	const default_value = Object.keys(router.query).length !== 0 ? props.endUsersAccounts.length : 10;
	const [rowsPerPage, setRowsPerPage] = useState(default_value);
	const [loading, setLoading] = useState(false);
	let endUsersAccountsMod = props.endUsersAccounts
								.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

	function handleChangePage(event, value) {
		setPage(value);
	}

	function handleChangeRowsPerPage(rowsPerPage) {
		setRowsPerPage(rowsPerPage);
	}


	if(loading){
		return (<FuseLoading/>)
	}

	if(endUsersAccountsMod.length <= 0){
		return (
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1, transition: { delay: 0.1 } }}
				className="flex flex-1 items-center justify-center h-full"
			>
				<div style={{height: "200px"}}>
				<Typography variant="body2" component="p" color="textSecondary">
				No data found
				</Typography>
				</div>
			</motion.div>
		)
	}

	return (
		<div className="w-full flex flex-col">
			
			{/* <motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1, transition: { delay: 0.1 } }}
				className="flex flex-1 items-center justify-end h-full"
			>
				<Button
				color="primary"
					onClick={()=>props.openAddAttributeDialog(props.platformModuleId)}
				>
					Add field
				</Button>
			</motion.div> */}
			<SwitchView selectedView={props.selectedView} endUsersAccounts={endUsersAccountsMod} 
						gotoDetailsPage={props.gotoDetailsPage} />
			
			<div className="p-10">
				<TablePagination
					className="flex-shrink-0 border-t-1 mt-10"
					component="div"
					count={props.endUsersAccounts.length}
					rowsPerPage={rowsPerPage}
					page={page}
					backIconButtonProps={{
						'aria-label': 'Previous Page'
					}}
					nextIconButtonProps={{
						'aria-label': 'Next Page'
					}}
					onChangePage={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</div>
		</div>
	);

}

function SwitchView({endUsersAccounts,selectedView,gotoDetailsPage}) {
	if(selectedView === 0){
		return(<ListView endUsersAccounts={endUsersAccounts} 
			gotoDetailsPage={gotoDetailsPage}/>)
	}else{
		return(<GridView endUsersAccounts={endUsersAccounts}
			gotoDetailsPage={gotoDetailsPage}
		/>)		
	}
}

export default withRouter(EndUsersAccountsTable)
